import { Module } from '@/constants/modules'
import * as React from 'react'

interface IModuleContextValue {
  module: Module
  setModule: React.Dispatch<React.SetStateAction<Module>>
}

const ModuleContext = React.createContext<IModuleContextValue>({
  module: 'all',
  setModule: () => null,
})

interface IModuleContextProviderProps {
  children: React.ReactNode
}

const ModuleContextProvider: React.FC<IModuleContextProviderProps> = ({ children }) => {
  const [module, setModule] = React.useState<Module>('all')

  const contextValue = React.useMemo(() => ({ module, setModule }), [module])

  return <ModuleContext.Provider value={contextValue}>{children}</ModuleContext.Provider>
}

export { ModuleContext, ModuleContextProvider }
